import { Component, OnInit } from '@angular/core';
import { FacadeService } from 'src/app/shared/service-facade/facade.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-debug-info',
  templateUrl: './debug-info.component.html',
  styleUrls: ['./debug-info.component.css']
})
export class DebugInfoComponent implements OnInit {
  sessionId$: Observable<string | null>;

  constructor(
    private _facade: FacadeService
  ) {
    this.sessionId$ = this._facade.sessionId$;
  }

  ngOnInit(): void {}

}
